import React from 'react'
import createReactClass from 'create-react-class'
import MonitoringTranslationsContainer from '../containers/monitoring-translations-container'

export default createReactClass({
  render () {
    return (
      <section>
        <MonitoringTranslationsContainer {...this.props}/>
      </section>
    )
  },
})



// WEBPACK FOOTER //
// ./src/views/monitoring-translations.js